import type { HTMLAttributes, ReactNode } from "react";
import { eyebrow, surface } from "./classes";

interface CardProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  /** `none` for a card that holds a full-bleed table. */
  padding?: "none" | "sm" | "md" | "lg";
  /** Rendered as an h2, so the card is a labelled section a screen reader can jump to. */
  title?: string;
}

const PADDING: Record<NonNullable<CardProps["padding"]>, string> = { none: "p-0 overflow-hidden", sm: "p-3", md: "p-6", lg: "p-8" };

/** A surface on the canvas: a labelled section when it has a title (design.md §10: labelled sections for anything persistent). */
export function Card({ children, padding = "md", title, className = "", ...props }: CardProps) {
  return (
    // --band-bg: a table's frozen filter row and column titles inside a card paint the card's surface, not the canvas.
    <section className={`${surface} ${PADDING[padding]} [--band-bg:var(--color-surface)] ${className}`} {...(title ? { "aria-label": title } : {})} {...props}>
      {title && <h2 className={`mb-3 ${eyebrow}`}>{title}</h2>}
      {children}
    </section>
  );
}
